export default __webpack_public_path__ + "static/media/fitnessTracker.ae80f779.png";